import { Helmet } from 'react-helmet-async';
// layouts
import LoginLayout from '../../layouts/login';

import { Alert, Stack, Typography, Box } from '@mui/material';
// hooks
import { useAuth } from 'iomart-hooks';
// components

import { LoginForm } from '../../sections/auth/login';
import { APP_META } from '../../config-global';

export default function Login() {
  const { loginError } = useAuth();

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{`Login | ${APP_META.siteName}`}</title>
        <meta name="description" content={APP_META.description} />
      </Helmet>

      <LoginLayout>
        <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" gutterBottom>
              {`Sign in to ${APP_META.siteName}`}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
          </Box>
        </Stack>

        {loginError && (
          <Alert severity="error" sx={{ mb: 3 }}>
            Login or password is <strong>incorrect</strong>. Please try again.
          </Alert>
        )}

        <LoginForm />
      </LoginLayout>
    </>
  );
}
